import { render, staticRenderFns } from "./deptUseWarning.vue?vue&type=template&id=60fa66e2&scoped=true"
import script from "./deptUseWarning.vue?vue&type=script&lang=js"
export * from "./deptUseWarning.vue?vue&type=script&lang=js"
import style0 from "./deptUseWarning.vue?vue&type=style&index=0&id=60fa66e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa66e2",
  null
  
)

export default component.exports